import { useTranslation } from "react-i18next";
import SubNav from "../../SubNav";

const ScoutNav = () => {
  const { t } = useTranslation("scout");
  const links = [
    { href: "/the-scout", text: t("news", "News"), exact: true },
    { href: "/the-scout/set-piece-takers", text: t("setPieces", "Set-Pieces") },
    { href: "/the-scout/player-news", text: t("availability", "Availability") },
  ];
  return <SubNav links={links} />;
};

export default ScoutNav;
